import { useNavigate } from '@tanstack/react-router';
import { type ReactNode } from 'react';

import { ListPageHeader } from '@apps/web/components/ui/list_page_header';
import { ListPageTabs } from '@apps/web/components/ui/list_page_tabs';
import { cn } from '@apps/web/lib/utils';

export type ConversationsPageTab = 'messages' | 'calls';

const TABS: ReadonlyArray<{
    readonly id: ConversationsPageTab;
    readonly label: string;
    readonly to: '/conversations' | '/voice-calls';
}> = [
    { id: 'messages', label: 'All', to: '/conversations' },
    { id: 'calls', label: 'Calls', to: '/voice-calls' },
];

// Under `ui_v3_components` the calls page is a tab of the
// conversations view rather than its own sidebar destination. Both routes
// render this header in place of their own title, so switching tabs is a
// route change and each page keeps its URL, search params, and deep links.
export function ConversationsPageTabs({
    active,
    actions,
    className,
}: {
    readonly active: ConversationsPageTab;
    readonly actions?: ReactNode;
    readonly className?: string;
}) {
    const navigate = useNavigate();
    return (
        <div className={cn('space-y-3', className)}>
            <ListPageHeader title="Conversations" actions={actions} />
            <ListPageTabs
                aria-label="Conversation type"
                data-testid="conversations-page-tabs"
                tabs={TABS}
                activeTab={active}
                onTabChange={(tabId) => {
                    const tab = TABS.find((entry) => entry.id === tabId);
                    if (tab && tab.id !== active) {
                        void navigate({ to: tab.to });
                    }
                }}
            />
        </div>
    );
}
